import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { AxiosResponse } from 'axios';
import { VerificationState } from '../verification.slice';
import { SippApi } from '../../../services/SippExpress'

export const sendOtpAsync = createAsyncThunk(
  'verification/sendOtp',
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await SippApi.sendOtp(email);
      return (response as AxiosResponse<any>).data;

    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Failed to send OTP');
    }
  }
);

export const sendOtpAsyncBuilder = (
  builder: ActionReducerMapBuilder<VerificationState>
) => {
  builder
    .addCase(sendOtpAsync.pending, (state) => {
      state.requestLoading = true;
      state.error = null;
      state.message = null;
    })
    .addCase(sendOtpAsync.fulfilled, (state, action) => {
      state.requestLoading = false;
      state.otpSent = action.payload.success;
      state.message = action.payload.message;
    })
    .addCase(sendOtpAsync.rejected, (state, action: PayloadAction<any>) => {
      state.requestLoading = false;
      state.error = action.payload.error || 'Something went wrong';
      state.otpSent = false;
    });
};